import { createApp } from 'vue';
import dJSON from 'dirty-json';
import module from './module.vue';

const moduleSelector = '.sds-updated-widget';

(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();

      const { data } = dJSON.parse(query.data);
      if (!Array.isArray(data) || !data.length) return;

      createApp(module, { data }).mount(query);
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
